import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { BaseService } from "app/core/base.service";
import { Observable } from "rxjs";
import { ViewModelWebContratoEmp } from "../models/viewModelWebContratoEmp.model";
import { WebContratoEmp } from "../models/webContratoEmp.model";
import { ApiService } from "./api.services";

export class WebContratoEmpService  extends ApiService implements BaseService<WebContratoEmp>{
    
    private strAction = 'api/WebContratoEmp';
    
    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
        }

        getAll(): Observable<WebContratoEmp[]> {
            return this.get<WebContratoEmp[]>(this.strAction + `/GetAll`);
        }

        deleteById(idPessoa: number) {
            return this.post(this.strAction + `/DeleteById?id=${idPessoa}`);
        }
    
        getContratosByPessoa(idContrato: number): Observable<ViewModelWebContratoEmp> {
            return this.get(this.strAction + `/GetContratoEmpByPessoa?idContrato=${idContrato}`);
        }

        // Post(WebContratoSeguro: WebContratoSeguro): Observable<WebContratoSeguro[]>{
        //     return this.post<WebContratoSeguro[]>(this.strAction + `/Post`, WebContratoSeguro);
        // }

        // Put(WebContratoSeguro: WebContratoSeguro): Observable<WebContratoSeguro> {
        //     return this.post<WebContratoSeguro>(this.strAction + `/Put`, WebContratoSeguro);
        // }

}